import React from 'react';
import BiDiv from '@wix/da-bi/pkg/Components/BiDiv';
import { SocialLoginProvider } from '../types';
import useGoogleSignIn from '../hooks/useGoogleSignIn';
import StandardView from './StandardView';
import IconView from './IconView';
const SocialButtonGoogle = ({ clientId, biData, className, view = 'standard', redirectToJoin = false, redirectToSisu, attemptSocialLogin, lazyload = false })=>{
    const { buttonRef, triggerLazyload } = useGoogleSignIn(clientId, lazyload, view, (response)=>attemptSocialLogin({
            provider: SocialLoginProvider.Google,
            token: response.credential,
            redirectToJoin,
            redirectToSisu
        }));
    return /*#__PURE__*/ React.createElement(BiDiv, {
        onMouseOver: lazyload ? triggerLazyload : undefined,
        onTouchStart: lazyload ? triggerLazyload : undefined,
        biData: biData,
        className: className,
        innerRef: (node)=>buttonRef.current = node
    }, lazyload && (view === 'standard' ? /*#__PURE__*/ React.createElement(StandardView, null) : /*#__PURE__*/ React.createElement(IconView, null)));
};
SocialButtonGoogle.displayName = 'SocialButtonGoogle';
export default SocialButtonGoogle;

//# sourceMappingURL=SocialButtonGoogle.js.map